'use client';
var classes = {"root":"m_db6d6462","section":"m_2242eb65","stripes-animation":"m_81a374bd","stripes-animation-vertical":"m_e0fb7a86","label":"m_91e40b74"};

export { classes as default };
//# sourceMappingURL=Progress.module.css.mjs.map
